import { schema } from 'normalizr';

const flagPageSchema = new schema.Entity('pages', {});

const pageCategorySchema = new schema.Entity('pageCategories', {
  pages: [flagPageSchema],
});

export default pageCategorySchema;
